import React from "react";

class PastBooking extends React.Component {
  render() {
    return (
      <>
        <h1 className="text-center">Past Booking</h1>
      </>
    );
  }
}

export default PastBooking;
